import { render, staticRenderFns } from "./AgendaMain.vue?vue&type=template&id=8a5bdd3a"
import script from "./AgendaMain.vue?vue&type=script&lang=js"
export * from "./AgendaMain.vue?vue&type=script&lang=js"
import style0 from "./AgendaMain.vue?vue&type=style&index=0&id=8a5bdd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports